import { render } from "./VsPopup.vue?vue&type=template&id=373cd0fb"
import script from "./VsPopup.vue?vue&type=script&lang=js"
export * from "./VsPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__